var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"regular lead",domProps:{"innerHTML":_vm._s(_vm.block.preamble.preamble)}})
}
var staticRenderFns = []

export { render, staticRenderFns }